import { computed } from "vue";
import { i18n } from "./../../i18n";
const { t } = i18n.global;

const menuItems = computed(() => [
    {
        slug: "contracts",
        path: "/contracts",
        name: "SingleOrders",

        label: t("contractshub.pages.menuItems.contractsSearch.linkLabel"),
        children: [
            {
                path: "/contracts/single-orders",
                name: "AllSingleOrders",
                label: t("contractshub.pages.menuItems.contractsSearch.children.singleOrders.linkLabel"),
            },
            {
                path: "/contracts/master-agreements",
                name: "AllMasterAgreements",
                label: t("contractshub.pages.menuItems.contractsSearch.children.masterAgreements.linkLabel"),
            },
        ],
    },
    {
        slug: "serviceRequests",
        path: "/service-requests",
        name: "ServiceRequests",
        label: t("contractshub.pages.menuItems.serviceRequests.linkLabel"),
        children: [
            {
                path: "/service-requests",
                name: "AllServiceRequests",
                label: t("contractshub.pages.menuItems.serviceRequests.children.AllServiceRequests.linkLabel"),
            },
        ],
    },
]);

export { menuItems };
